export default "__VITE_ASSET__rAS4C39l__"